import { IPOSFile } from "@/interfaces/pos-files/pos-files";
import {
  ICustomField,
  ICustomFieldAnswer,
  QuestionType,
} from "@/types/db/product-category";
import {
  IProductSlotBooking,
  IUpdatedBooking,
} from "@/types/db/product-slot-booking";
import { insertFilesIDs } from "../helpers/pos-files";

/**
 * Take a list of synched bookings and extract files Ids if we have custom fiedls of type FILE answered
 * Then, insert files Ids into a separate DB to trigger synching process
 */
export async function checkAndSynchBookingsFiles(
  bookings: IProductSlotBooking[]
) {
  // If bookings synched has custom fields files in them, then we need to insert the files IDs into their DB
  // to trigger their synching process
  const filesIDs: IPOSFile[] = [];
  // Going to fill in filesIDs

  // Lets check BOOKING answers first
  for (let i = 0; i < bookings.length; i++) {
    if (
      bookings[i].customFieldsAnswers &&
      bookings[i].customFieldsAnswers !== undefined &&
      bookings[i].customFieldsAnswers?.length
    ) {
      const answers = bookings[i].customFieldsAnswers;
      if (answers) {
        for (let j = 0; j < answers.length; j++) {
          if (answers[j].customField.questionType === QuestionType.FILE) {
            // This is a file custom field, lets see if it was answered
            if (answers[j]?.answer && answers[j].fileID) {
              // Lets insert fileId into the database
              filesIDs.push({
                _id: String(answers[j].fileID),
                data: { bookingUuid: bookings[i].uuid },
              });
            }
          }
        }
      }
    }
  }
  // Lets now check TICKET answers
  const pssLists = bookings.map((b) => b.pssList).flat();
  for (let i = 0; i < pssLists.length; i++) {
    if (
      pssLists[i].customFieldsAnswers &&
      pssLists[i].customFieldsAnswers !== undefined &&
      pssLists[i].customFieldsAnswers?.length
    ) {
      const answers = pssLists[i].customFieldsAnswers;
      if (answers) {
        for (let j = 0; j < answers.length; j++) {
          if (answers[j].customField.questionType === QuestionType.FILE) {
            // This is a file custom field, lets see if it was answered
            if (answers[j]?.answer && answers[j].fileID) {
              // Lets insert fileId into the database
              filesIDs.push({
                _id: String(answers[j].fileID),
                data: { pssUuid: pssLists[i].uuid },
              });
            }
          }
        }
      }
    }
  }
  // Lets now insert filesIDs elements into the database
  await insertFilesIDs(filesIDs);
}

/**
 * Take a synched updated booking (diff object) and extract files Ids if we have custom fiedls of type FILE answered
 * Then, insert files Ids into a separate DB to trigger synching process
 */
export async function checkAndSynchUpdatedBookingFiles(
  diffObject: IUpdatedBooking
) {
  const filesIDs: IPOSFile[] = [];
  // In case of Edit order we get filesIDs from:
  // newBookingCustomFieldsAnswers / newPSSCustomFieldsAnswers / updatedBookingCustomFieldsAnswers / updatedPSSCustomFieldsAnswers

  // Get filesIds from newBookingCustomFieldsAnswers
  if (
    diffObject.diffObject.newBookingCustomFieldsAnswers &&
    diffObject.diffObject.newBookingCustomFieldsAnswers !== undefined &&
    diffObject.diffObject.newBookingCustomFieldsAnswers?.length
  ) {
    const answers = diffObject.diffObject
      .newBookingCustomFieldsAnswers as ICustomFieldAnswer[];
    if (answers) {
      for (let j = 0; j < answers.length; j++) {
        if (answers[j].customField.questionType === QuestionType.FILE) {
          // This is a file custom field, lets see if it was answered
          if (answers[j]?.answer && answers[j].fileID) {
            // Lets insert fileId into the database
            filesIDs.push({
              _id: String(answers[j].fileID),
              data: { bookingUuid: answers[j].bookingUuid },
            });
          }
        }
      }
    }
  }

  // Get filesIds from newPSSCustomFieldsAnswers
  if (
    diffObject.diffObject.newPSSCustomFieldsAnswers &&
    diffObject.diffObject.newPSSCustomFieldsAnswers !== undefined &&
    diffObject.diffObject.newPSSCustomFieldsAnswers?.length
  ) {
    const answers = diffObject.diffObject
      .newPSSCustomFieldsAnswers as ICustomFieldAnswer[];
    if (answers) {
      for (let j = 0; j < answers.length; j++) {
        if (answers[j].customField.questionType === QuestionType.FILE) {
          // This is a file custom field, lets see if it was answered
          if (answers[j]?.answer && answers[j].fileID) {
            // Lets insert fileId into the database
            filesIDs.push({
              _id: String(answers[j].fileID),
              data: { pssUuid: answers[j].pssUuid },
            });
          }
        }
      }
    }
  }

  // Get filesIds from updatedBookingCustomFieldsAnswers
  if (
    diffObject.diffObject.updatedBookingCustomFieldsAnswers &&
    diffObject.diffObject.updatedBookingCustomFieldsAnswers !== undefined &&
    diffObject.diffObject.updatedBookingCustomFieldsAnswers?.length
  ) {
    const answers = diffObject.diffObject
      .updatedBookingCustomFieldsAnswers as ICustomFieldAnswer[];
    if (answers) {
      for (let j = 0; j < answers.length; j++) {
        if (answers[j].customField.questionType === QuestionType.FILE) {
          // This is a file custom field, lets see if it was answered
          if (answers[j]?.answer && answers[j].fileID) {
            // Lets insert fileId into the database
            filesIDs.push({
              _id: String(answers[j].fileID),
              data: { bookingUuid: answers[j].bookingUuid },
            });
          }
        }
      }
    }
  }

  // Get filesIds from updatedPSSCustomFieldsAnswers
  if (
    diffObject.diffObject.updatedPSSCustomFieldsAnswers &&
    diffObject.diffObject.updatedPSSCustomFieldsAnswers !== undefined &&
    diffObject.diffObject.updatedPSSCustomFieldsAnswers?.length
  ) {
    const answers = diffObject.diffObject
      .updatedPSSCustomFieldsAnswers as ICustomFieldAnswer[];
    if (answers) {
      for (let j = 0; j < answers.length; j++) {
        if (answers[j].customField.questionType === QuestionType.FILE) {
          // This is a file custom field, lets see if it was answered
          if (answers[j]?.answer && answers[j].fileID) {
            // Lets insert fileId into the database
            filesIDs.push({
              _id: String(answers[j].fileID),
              data: { pssUuid: answers[j].pssUuid },
            });
          }
        }
      }
    }
  }

  // Lets now insert filesIDs elements into the database
  await insertFilesIDs(filesIDs);
}
